import { render, staticRenderFns } from "./InvetariosGral.view.vue?vue&type=template&id=60c29654&"
import script from "./InvetariosGral.view.vue?vue&type=script&lang=js&"
export * from "./InvetariosGral.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports